import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js' 


export const cscCarousel = {
  columnGapDesktop: css`var(--csc-carousel-column-gap-desktop, ${csSpacing.spacing05})`,
  columnGapMobile: css`var(--csc-carousel-column-gap-mobile, ${csSpacing.spacing05})`,
  rowGap: css`var(--csc-carousel-row-gap, ${csSpacing.spacing08})`,
  headerAlignment: css`var(--csc-carousel-header-align-items, start)`,
  headerRowGap: css`var(--csc-carousel-header-row-gap, ${csSpacing.spacing05})`,
}

export const style: CSSResult = css`
  .csc-carousel {
    display: flex;
    flex-direction: column;
    position: relative;
    row-gap: ${cscCarousel.rowGap};
  }

  .header {
    display: flex;
    flex-direction: column;
    row-gap: ${cscCarousel.headerRowGap};
    align-items: ${cscCarousel.headerAlignment};
  }

  .body {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: ${cscCarousel.rowGap};
  }

  .carousel-wrapper {
    position: relative;
    width: 100%;
  }

  /* Full-width scrolling support */
  .csc-carousel[full-width] .carousel-wrapper {
    margin-inline: calc(-1 * var(--csc-carousel-container-padding, 0));
    width: calc(100% + 2 * var(--csc-carousel-container-padding, 0));
  }

  .csc-carousel[full-width] .slides-wrapper {
    padding-inline: var(--csc-carousel-container-padding, 0);
  }

  .slides-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    /* Native horizontal scrolling and snapping */
    scroll-snap-type: x mandatory;
    /* Allow horizontal dragging without vertical jitter on touch */
    touch-action: pan-y;
    user-select: none;
    -webkit-user-drag: none;
    /* Keep horizontal overscroll inside the carousel, but let vertical scroll reach the page */
    overscroll-behavior-x: contain;
    overscroll-behavior-y: auto;
    /* Enable momentum scrolling */
    -webkit-overflow-scrolling: touch;
  }

  .slides-wrapper.dragging {
    scroll-snap-type: none;
  }

  .carousel {
    display: flex;
    height: 100%;
    width: 100%;
    column-gap: ${cscCarousel.columnGapMobile};
  }

  @media (min-width: ${SCREENS.medium}) {
    .carousel {
      column-gap: ${cscCarousel.columnGapDesktop};
    }
  }

  .csc-carousel[stretch-tiles] .carousel {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: calc((100% - (var(--items-per-view) - 1) * var(--csc-carousel-column-gap-mobile, ${csSpacing.spacing05})) / var(--items-per-view));
  }

  @media (min-width: ${SCREENS.medium}) {
    .csc-carousel[stretch-tiles] .carousel {
      grid-auto-columns: calc((100% - (var(--items-per-view) - 1) * var(--csc-carousel-column-gap-desktop, ${csSpacing.spacing05})) / var(--items-per-view));
    }
  }

  .csc-carousel[stretch-tiles] .carousel ::slotted(*) {
    --csc-carousel-item-align-items: stretch;
  }

  .carousel ::slotted(*) {
    flex: 0 0 calc((100% - (var(--items-per-view) - 1) * var(--csc-carousel-column-gap-mobile, ${csSpacing.spacing05})) / var(--items-per-view));
    scroll-snap-align: start;
    scroll-snap-stop: always;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  @media (min-width: ${SCREENS.medium}) {
    .carousel ::slotted(*) {
      flex: 0 0 calc((100% - (var(--items-per-view) - 1) * var(--csc-carousel-column-gap-desktop, ${csSpacing.spacing05})) / var(--items-per-view));
    }
  }

  .csc-carousel[partial-view] .carousel ::slotted(*) {
    scroll-snap-stop: normal;
  }

  /* Hide scrollbars where possible */
  .slides-wrapper::-webkit-scrollbar { display: none; }
  .slides-wrapper { scrollbar-width: none; }

  .top-controls {
    display: flex;
    gap: ${csSpacing.spacing06};
  }

  .sides-controls {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: space-between;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .control-previous {
    transform: translateX(calc(-0.5 * var(--cse-icon-button-default-size)));
    transition: transform 120ms ease;
  }

  .control-next {
    transform: translateX(calc(0.5 * var(--cse-icon-button-default-size)));
    transition: transform 120ms ease;
  }

  .control-previous:active {
    transform: translateX(calc(-0.5 * var(--cse-icon-button-default-size))) scale(0.88);
  }

  .control-next:active {
    transform: translateX(calc(0.5 * var(--cse-icon-button-default-size))) scale(0.88);
  }

  .top-controls .control-previous:active {
    transform: scale(0.88);
  }

  .top-controls .control-next:active {
    transform: scale(0.88);
  }
`
